import React from 'react';
import { Task } from '../../../types/task';
import { TaskItemBase } from './TaskItemBase';

// --- TaskItem Component Definition ---
const TaskItemComponent = ({
  task,
  onSelect,
  onToggleDone,
  onDelete
}: {
  task: Task;
  onSelect: (task: Task) => void;
  onToggleDone: (task: Task, done: boolean) => void;
  onDelete: (id: string) => void;
}) => {
  return (
    <TaskItemBase
      task={task}
      onSelect={onSelect}
      onToggleDone={onToggleDone}
      onDelete={onDelete}
      options={{
        showProjectName: false,
        showDetailedTime: false
      }}
    />
  );
};

// 使用 React.memo 包装组件，避免不必要的重新渲染
export const TaskItem = React.memo(TaskItemComponent, (prevProps, nextProps) => {
  // 自定义比较函数，只有在关键属性变化时才重新渲染
  return (
    prevProps.task.id === nextProps.task.id &&
    prevProps.task.title === nextProps.task.title &&
    prevProps.task.done === nextProps.task.done &&
    prevProps.task.vital === nextProps.task.vital &&
    prevProps.task.urgent === nextProps.task.urgent &&
    prevProps.task.startAt === nextProps.task.startAt &&
    prevProps.task.dueAt === nextProps.task.dueAt &&
    prevProps.task.cost === nextProps.task.cost &&
    prevProps.task.notes === nextProps.task.notes &&
    prevProps.task.projectId === nextProps.task.projectId
  );
});